import axios from '@/core/axios';

class AndonService {
  createIntervention(locationName: string, reason: string): Promise<void> {
    return axios
      .post('/andon/interventions', { location_name: locationName, call_reason: reason })
      .then(resp => resp?.data);
  }
}

export const andonService = new AndonService();
